
import React from "react";
import Header from "./Header";
import Footer from "./Footer";

function Blog() {
  return (
    <div>
      <Header />
      {/* Hero Section Start */}
      <div
        className="container-fluid"
        style={{
          marginBottom: "90px",
          background: "linear-gradient(rgba(9, 30, 62, .7), rgba(9, 30, 62, .7)), url('/img/our blog (1270 x 400).jpg') center center no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center",
          minHeight: "60vh"
        }}>
        <div className="row py-5">
          <div className="col-12 pt-lg-5 mt-lg-5 text-center">
            <h1 className="display-4 text-white animated zoomIn">Our Blog</h1>
            <a href="/" className="h5 text-white">Home</a>
            <i className="far fa-circle text-white px-2"></i>
            <a href="/blog" className="h5 text-white fs-3">Blog</a>
          </div>
        </div>
      </div>
      {/* Hero Section Ends here */}
      <div className="container-fluid py-5">
        <div className="container">
          <div className="row g-5">
            <div className="col-lg-12">
              <div className="section-title text-center position-relative pb-3 mb-5 mx-auto" style={{maxWidth: "600px"}}>
                <h5 className="fw-bold text-primary text-uppercase">Our Blog</h5>
                <h1 className="mb-0">Read The Latest Articles from Our Blog Post</h1>
              </div>
              <div className="row g-5">
                <div className="col-lg-4 wow slideInUp" data-wow-delay="0.3s">
                  <div className="blog-item bg-light rounded overflow-hidden">
                    <div className="blog-img position-relative overflow-hidden">
                      <img className="img-fluid" src="/img/400 x 280-20240128T111714Z-001/400 x 280/Social Media Marketing for diff. Industries.jpg" alt="Social Media Marketing" />
                      <span className="position-absolute top-0 start-0 bg-primary text-white rounded-end mt-5 py-2 px-4">
                        Social Media
                      </span>
                    </div>
                    <div className="p-4">
                      <div className="d-flex mb-3">
                        <small className="me-3">
                          <i className="far fa-user text-primary me-2"></i>Anwar Hussain
                        </small>
                        <small>
                          <i className="far fa-calendar-alt text-primary me-2"></i> 22nd Jan, 2024
                        </small>
                      </div>
                      <h4 className="mb-3">Social Media Marketing By Industry</h4>
                      <a className="text-uppercase" href="https://www.brandliftmm.com/blog/smm-by-industry.html">
                        Read More <i className="bi bi-arrow-right"></i>
                      </a>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 wow slideInUp" data-wow-delay="0.6s">
                  <div className="blog-item bg-light rounded overflow-hidden">
                    <div className="blog-img position-relative overflow-hidden">
                      <img className="img-fluid" src="/img/400 x 280-20240128T111714Z-001/400 x 280/Generating Online Leads Through Social Media Marketing.jpg" alt="Generating Leads" />
                      <span className="position-absolute top-0 start-0 bg-primary text-white rounded-end mt-5 py-2 px-4">
                        Social Media
                      </span>
                    </div>
                    <div className="p-4">
                      <div className="d-flex mb-3">
                        <small className="me-3">
                          <i className="far fa-user text-primary me-2"></i>Anwar Hussain
                        </small>
                        <small>
                          <i className="far fa-calendar-alt text-primary me-2"></i>12th Jan, 2024
                        </small>
                      </div>
                      <h4 className="mb-3">Generating Leads Through Social Media Marketing</h4>
                      <a className="text-uppercase" href="https://www.brandliftmm.com/blog/generating-leads-through-smm.html">
                        Read More..<i className="bi bi-arrow-right"></i>
                      </a>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 wow slideInUp" data-wow-delay="0.9s">
                  <div className="blog-item bg-light rounded overflow-hidden">
                    <div className="blog-img position-relative overflow-hidden">
                      <img className="img-fluid" src="/img/400 x 280-20240128T111714Z-001/400 x 280/Cheap Social Media Services.jpg" alt="Affordable Services" />
                      <span className="position-absolute top-0 start-0 bg-primary text-white rounded-end mt-5 py-2 px-4">
                        Social Media
                      </span>
                    </div>
                    <div className="p-4">
                      <div className="d-flex mb-3">
                        <small className="me-3">
                          <i className="far fa-user text-primary me-2"></i>Anwar Hussain
                        </small>
                        <small>
                          <i className="far fa-calendar-alt text-primary me-2"></i>3rd Jan, 2024
                        </small>
                      </div>
                      <h4 className="mb-3">Affordable Social Media Services by Brand Lift.</h4>
                      <a className="text-uppercase" href="https://www.brandliftmm.com/blog/affordable-marketing-services.html">
                        Read More <i className="bi bi-arrow-right"></i>
                      </a>
                    </div>
                  </div>
                </div>
                
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Blog;